// ─── DESIGN TOKENS — Obsidian Core ───────────────────────────
export const COLORS = {
  abyss:      "#080B12",
  void:       "#0D1117",
  surface:    "#161B22",
  border:     "#21262D",
  borderMid:  "#30363D",
  cyan:       "#00D4FF",
  cyanDim:    "rgba(0,212,255,0.15)",
  cyanGlow:   "rgba(0,212,255,0.08)",
  cyanHover:  "rgba(0,212,255,0.4)",
  green:      "#3FB950",
  red:        "#F85149",
  amber:      "#D29922",
  text:       "#E6EDF3",
  muted:      "#7D8590",
};

export const FONTS = {
  mono: "'JetBrains Mono', monospace",
  body: "'Inter', sans-serif",
};

export const SPACING = {
  xs: 4,
  sm: 8,
  md: 12,
  base: 16,
  lg: 20,
  xl: 24,
  xxl: 32,
};

export const SIDEBAR_WIDTH     = 240;
export const SIDEBAR_COLLAPSED = 56;
export const TOPBAR_HEIGHT     = 48;

export const TRANSITION = {
  fast:    "80ms ease-out",
  normal:  "120ms ease-out",
  medium:  "220ms ease-out",
  slow:    "350ms ease-out",
};
